import React, { useState } from 'react'
import { Box, Grid, makeStyles, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useFormik } from 'formik';
import TextFieldComponent from './form/TextFieldComponent';
import * as Yup from 'yup';
import NewsletterIconSvg from '../svgs/NewsletterIconSvg';

import FacebookComponent from './FacebookComponent';
import SubmitButtonComponent from './form/SubmitButtonComponent';
// import { useGoogleReCaptcha } from 'react-google-recaptcha-v3';
import { POST } from '../functions/superagentSending';
import { NEWSLETTER_API } from '../constants/api';
// import { RECAPTCHA_ACTION } from '../constants';


const paddingCont = (theme) => ({
    padding: `${theme.spacing(8)}px ${theme.spacing(6)}px`,
    [theme.breakpoints.down("xs")]: {
        padding: `${theme.spacing(6)}px ${theme.spacing(4)}px`,
    },
})
const useStyles = makeStyles((theme) => ({
    grid: {
        // marginTop: 80,
        position: 'relative',
        zIndex: 2,
        marginBottom: 80,
        [theme.breakpoints.down("md")]: {
            marginBottom: 0,
        },
    },
    newsletterCont: {
        background: theme.palette.background.gray,
        ...paddingCont(theme),
        [theme.breakpoints.down("xs")]: {
            width: '100%',
        },
    },
    contBtn: {
        [theme.breakpoints.down("xs")]: {
            width: '100%',
        },
    },
    socialCont: {
        background: theme.palette.primary.main,
        ...paddingCont(theme),
        [theme.breakpoints.down("md")]: {
            display: 'flex',
            alignItems: 'center',
        },
    },
    iconGrid: {
        position: 'relative',
        [theme.breakpoints.down("md")]: {
            display: 'none',
        },
    },
    iconBox: {
        position: 'absolute',
        top: 0,
        bottom: 0,
        display: 'flex',
        zIndex: 2,
        alignItems: 'center',
        justifyContent: 'center'
    },
    socialContGrid: {
        display: 'flex',
        alignItems: 'center',
    },
    textField: {
        [theme.breakpoints.down("xs")]: {
            width: '100%',
        },
        '& input': {
            "&::placeholder": {
                textAlign: 'center',
            },
        },
    },
    formCont: {
        display: 'flex',
        alignItems: 'flex-start',
        [theme.breakpoints.down("xs")]: {
            flexDirection: 'column',
        }
    },
    btn: {
        border: `2px solid ${theme.palette.primary.main}`,
        [theme.breakpoints.down("xs")]: {
            width: '100%',
        }
    },
    socialTitle: {
        color: theme.palette.text.white,
    },
    socialSubtitle: {
        color: theme.palette.text.white,
    },
    facebookCont: {
        marginLeft: 40,
    },
    newsletterTitleCont: {
        marginTop: 20,
        marginBottom: 20,
    },
    newsletterIcon: {
        width: '100%',
    }
}))


const newsLetterSchema = (t) => Yup.object().shape({
    email: Yup.string()
        .required(t('validation.required'))
        .email(t('validation.email')),
});

const NewsletterComponent = (props) => {
    const classes = useStyles();
    const { t } = useTranslation();
    // const { executeRecaptcha } = useGoogleReCaptcha();
    const [loading, setLoading] = useState(false);
    const [successSent, setSuccessSent] = useState(false);
    const [errorSent, setErrorSent] = useState(false);
    const formik = useFormik({
        validationSchema: newsLetterSchema(t),
        initialValues: {
            email: '',
        },
        onSubmit: values => {
            setLoading(true)
            setSuccessSent(false)
            setErrorSent(false)
            // executeRecaptcha(RECAPTCHA_ACTION).then((token) => {
            //  _recaptcha: token
                POST(NEWSLETTER_API, { ...values, })
                    .then((success) => {
                        setLoading(false)
                        setSuccessSent(true)
                    })
                    .catch((error) => {
                        setLoading(false)
                        setErrorSent(true)
                    })
            // }).catch(() => {
            //     setLoading(false)
            //     setErrorSent(true)
            // })
        },
    });
    return (
        <Grid container className={classes.grid} id='newsletter'>
            <Grid item md={6} xs={12} className={classes.newsletterCont}>
                <Grid container alignItems='center'>
                    <Grid item lg={6} xs={12} className={classes.newsletterTitleCont}>
                        <Typography variant='h2'>{t('newsletter.title')}</Typography>
                        <Typography >{t('newsletter.subtitle')}</Typography>
                    </Grid>
                    <Grid item lg={6} xs={12}>
                        <form className={classes.formCont} onSubmit={formik.handleSubmit}>
                            <TextFieldComponent
                                type='email'
                                fullWidth
                                autoComplete='email'
                                classNameBox={classes.textField}
                                formikProps={formik}
                                id='email'
                            />
                            <SubmitButtonComponent
                                contClassName={classes.contBtn}
                                title={t('btns.newsletter')}
                                className={classes.btn}
                                loading={loading}
                                error={errorSent}
                                success={successSent}
                            />
                        </form>
                    </Grid>
                </Grid>
            </Grid>
            <Grid item md={6} xs={12} className={classes.socialCont}>
                <Grid container>
                    <Grid item lg={6} md={12} sm={12} xs={12} className={classes.socialContGrid}>
                        <Box>
                            <Typography variant='h2' className={classes.socialTitle}>{t('newsletter.social_title')}</Typography>
                            <Typography className={classes.socialSubtitle}>{t('newsletter.social_subtitle')}</Typography>
                        </Box>
                        <FacebookComponent
                            className={classes.facebookCont}
                        />
                    </Grid>
                    <Grid item lg={6} xs={12} className={classes.iconGrid}>
                        <Box className={classes.iconBox}>
                            <NewsletterIconSvg
                                className={classes.newsletterIcon}
                            />
                        </Box>

                    </Grid>
                </Grid>
            </Grid>
        </Grid>
    )
}

export default React.memo(NewsletterComponent);